var React = require('react');

function ShopNation (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"shop-nation"),React.createElement("path",{"d":"M72.309 25.465c0-14.063-11.401-25.465-25.465-25.465s-25.465 11.402-25.465 25.465v461.071c0 14.063 11.401 25.464 25.465 25.464s25.465-11.401 25.465-25.464v-201.54c0.001 0.002 0.005 0.002 0.007 0.003l-0.007-259.534zM410.631 139.408c-4.434-5.96-4.384-13.972 0.124-19.388 24.071-28.755 48.834-52.337 72.212-71.153 20.606-16.584-6.261-28.678-12.288-31.215-122.663-51.645-245.215 56.428-367.807 23.524v255.102c122.774 32.925 245.551-75.615 368.324-23.298 5.993 2.538 11.464 1.913 14.101-2.059 2.637-3.957 1.981-10.755-1.689-17.415-24.325-43.965-48.653-81.213-72.978-114.098z","key":1})]);
}

ShopNation.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = ShopNation;

ShopNation.default = ShopNation;
